// extracted by mini-css-extract-plugin
module.exports = {"root":"FlatfyLogo_root__1swB2","root_current":"FlatfyLogo_root_current__1Mj9P","rootCurrent":"FlatfyLogo_root_current__1Mj9P"};
    if(module.hot) {
      // 1586964020211
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  